<template>
    <div class="portfolio container"  id="portfolio">
        <p class="title ">See What Our Agency <span class="one">Offers</span> & What We <span class="two">Provide</span> </p>
        <div class="row child">
            <div class="col-lg-3 col-sm-6 col-12 ii mt-sm-5">
                <div class="item-child text-center">
                    <img src="../assets/portfolio-image.png" alt="">
                </div>
                <div class="row">
                    <div class="box-text text-center col-11">
                        <h4>Performance Tests</h4>
                        <p>Lorem ipsum dolor sit ameti ctetur aoi adipiscing eto.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-12 col-sm-6 ii mt-sm-5">
                <div class="item-child text-center">
                    <img src="../assets/portfolio-image.png" alt="">
                </div>
                <div class="row">
                    <div class="box-text text-center  col-11">
                        <h4>Performance Tests</h4>
                        <p>Lorem ipsum dolor sit ameti ctetur aoi adipiscing eto.</p>
                    </div>
                </div>
            </div>
            <div class="col-lg-3 col-12 col-sm-6 ii mt-sm-5">
                <div class="item-child text-center">
                    <img src="../assets/portfolio-image.png" alt="">
                </div>
                <div class="row">
                    <div class="box-text text-center  col-11">
                        <h4>Performance Tests</h4>
                        <p>Lorem ipsum dolor sit ameti ctetur aoi adipiscing eto.</p>
                    </div>
                </div>
                </div>
            <div class="col-lg-3 col-12 col-sm-6 ii mt-sm-5"><div class="item-child text-center">
                <img src="../assets/portfolio-image.png" alt="">
            </div>
            <div class="row ">
                <div class="box-text text-center  col-11">
                    <h4>Performance Tests</h4>
                    <p>Lorem ipsum dolor sit ameti ctetur aoi adipiscing eto.</p>
                </div>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
    name:'portfolio',
    }
</script>

<style scoped>
*{
    box-sizing: border-box;

}
.ii{
    position: relative;
    margin-top:100px;
    margin-bottom: 100px;
}
@media (max-width: 575px) {
    .ii{
        margin-bottom: 20px;
    }
}
.row .box-text{
    position:absolute;
    background:linear-gradient(105deg, rgba(255, 77, 30, 1) 0%, rgba(255, 44, 109, 1) 100%);
    padding:20px 5px;
    color: white;
    border-radius: 20px;
    top:0;
    left:5%;
    right:5%;
    z-index: -10;
    opacity: 0;
    transition: all .5s;
    visibility: hidden
}
.item-child:hover + .row .box-text{
    top:-100px;
    visibility:visible;
    opacity: 1;
    z-index: 1;
}
.item-child:hover{
    transform:translate(0,60px)
}
@media (min-width:992px) {
    .item-child:hover+.row .box-text {
            top: -75px;
            z-index: -100;
        }
    
        .item-child:hover {
            transform: translate(0, 40px)
        }
}
.row .box-text::before{
    content: '';
        position: absolute;
        border-color: rgb(224 224 224 / 0%) rgb(240, 0, 0) rgb(255, 16, 16) #00800000;
        border-style: solid solid solid solid;
        border-width: 20px;
        bottom: -5px;
        left: 40%;
        right: 50%;
        transform: rotate(45deg)

}
.box-text h4 {
    font-weight: 600;
    margin-top:10px; 
    margin-bottom:10px; 
    font-size: 20px;
}
.item-child{
    background-color: #fff;
    padding: 40px ;
    padding-left: 60px;
    padding-right: 60px;
    border-radius: 30px;
    /* box-shadow: 0.3px 0.3px 3px black ;  */
    transition: all .9s; 
}
.child{
    margin-top:100px;
}
.portfolio {
    margin-top: 100px;
}
.title{
    width:40%;
    margin-left: auto;
    margin-right: auto;
    color:black;
    font-weight: 600;
    font-size: 40px;
}
@media (max-width: 992px){
    .title{
        width: 80%;
    }
}
.title .one {
    color:#03a4ed;
}
.title .two {
    color:#fe3f40;
}
</style>